<span class="_flag"
      [ngClass]="'_flag-' + code?.toLowerCase()"></span>